import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import type { LinkProps as Props } from './types';

// this component returns the `react-router-dom` Link component if `to` property exists
// otherwise it returns the link's children

export const Link = memo(
  ({ className, children, to, ...otherProps }: Props) => {
    if (!to) return <>{children}</>;

    return (
      <Styled.Wrapper
        className={classnames('Link', className)}
        sx={otherProps.sx}
        to={to}
        {...otherProps}
      >
        {children}
      </Styled.Wrapper>
    );
  }
);

Link.displayName = 'Link';
